const vpsOciTypes = {
  GET_VPS_OCI_REQUEST: 'GET_VPS_OCI_REQUEST',
  SET_VPS_OCI_DATA: 'SET_VPS_OCI_DATA',
  VPS_OCI_SET_LOADING: 'VPS_OCI_SET_LOADING',

  STATUS_VPS_OCI_REQUEST: 'STATUS_VPS_OCI_REQUEST',
  STATUS_VPS_OCI_DATA: 'STATUS_VPS_OCI_DATA',
  STATUS_VPS_OCI_LOADING: 'STATUS_VPS_OCI_LOADING',

  REBOOT_VPS_REQUEST: 'REBOOT_VPS_REQUEST',
  REBOOT_VPS_SET_LOADING: 'REBOOT_VPS_SET_LOADING',

  REBUILD_VPS_REQUEST: 'REBUILD_VPS_REQUEST',
  REBUILD_VPS_SET_LOADING: 'REBUILD_VPS_SET_LOADING',
  REBUILD_VPS_SET_STATUS: 'REBUILD_VPS_SET_STATUS',
  REBUILD_VPS_RESET: 'REBUILD_VPS_RESET',

  CHANGE_IMAGE_VPS_REQUEST: 'CHANGE_IMAGE_VPS_REQUEST',
  CHANGE_IMAGE_VPS_SET_LOADING: 'CHANGE_IMAGE_VPS_SET_LOADING',
  CHANGE_IMAGE_VPS_SET_STATUS: 'CHANGE_IMAGE_VPS_SET_STATUS',
  CHANGE_IMAGE_VPS_SET_DATA: 'CHANGE_IMAGE_VPS_SET_DATA',
  CHANGE_IMAGE_VPS_RESET: 'CHANGE_IMAGE_VPS_RESET',

  SAVE_SSH_PASSWORD_REQUEST: 'SAVE_SSH_PASSWORD_REQUEST',
  SAVE_SSH_PASSWORD_SET_LOADING: 'SAVE_SSH_PASSWORD_SET_LOADING',
  SAVE_SSH_PASSWORD_SET_SUCCESS: 'SAVE_SSH_PASSWORD_SET_SUCCESS',

  OPEN_SSH_TERMINAL_REQUEST: 'OPEN_SSH_TERMINAL_REQUEST',
  OPEN_SSH_TERMINAL_SET_LOADING: 'OPEN_SSH_TERMINAL_SET_LOADING',
  OPEN_SSH_TERMINAL_SET_DATA: 'OPEN_SSH_TERMINAL_SET_DATA',

  SAVE_TOUR_STEP_REQUEST: 'SAVE_TOUR_STEP_REQUEST',
  GET_TOUR_REQUEST: 'GET_TOUR_REQUEST',
  SET_TOUR_DATA: 'SET_TOUR_DATA',

  GET_LISTING_UPGRADE_VPS_OCI: 'GET_LISTING_UPGRADE_VPS_OCI',
  SET_DATA_LISTING_UPGRADE_VPS_OCI: 'SET_DATA_LISTING_UPGRADE_VPS_OCI',
  SET_LOADING_LISTING_UPGRADE_VPS_OCI: 'SET_LOADING_LISTING_UPGRADE_VPS_OCI',

  GET_DETAILS_UPGRADE_VPS_OCI: 'GET_DETAILS_UPGRADE_VPS_OCI',
  SET_DATA_DETAILS_UPGRADE_VPS_OCI: 'SET_DATA_DETAILS_UPGRADE_VPS_OCI',
  SET_LOADING_DETAILS_UPGRADE_VPS_OCI: 'SET_LOADING_DETAILS_UPGRADE_VPS_OCI',

  UPGRADE_VPS_OCI: 'UPGRADE_VPS_OCI',
  SET_DATA_UPGRADE_VPS_OCI: 'SET_DATA_UPGRADE_VPS_OCI',
  SET_LOADING_UPGRADE_VPS_OCI: 'SET_LOADING_UPGRADE_VPS_OCI',
  RESET_UPGRADE_VPS_OCI: 'RESET_UPGRADE_VPS_OCI',

  SAVE_TOKEN_OPENCLAW_REQUEST: 'SAVE_TOKEN_OPENCLAW_REQUEST',
  SAVE_TOKEN_OPENCLAW_SET_LOADING: 'SAVE_TOKEN_OPENCLAW_SET_LOADING',
  SAVE_TOKEN_OPENCLAW_SET_SUCCESS: 'SAVE_TOKEN_OPENCLAW_SET_SUCCESS',
};

export default vpsOciTypes;
